import type {
  AdminUgcApi,
  AdminUgcBrowseParams,
  AdminUgcBrowseResponse,
  AdminUgcListReportsParams,
  AdminUgcListReportsResponse,
  AdminUgcResolveAction,
} from './AppApi'

export class MockAdminUgcApi implements AdminUgcApi {
  async browse(
    _params?: AdminUgcBrowseParams,
  ): Promise<AdminUgcBrowseResponse> {
    console.warn('[RUN:mock] adminUgc.browse() returning empty results')
    return { entries: [] }
  }

  async removeEntry(_entryId: string): Promise<void> {
    console.warn('[RUN:mock] adminUgc.removeEntry() is a no-op in mock mode')
  }

  async listReports(
    _params?: AdminUgcListReportsParams,
  ): Promise<AdminUgcListReportsResponse> {
    console.warn('[RUN:mock] adminUgc.listReports() returning empty results')
    return { reports: [] }
  }

  async resolveReport(
    _reportId: string,
    _action: AdminUgcResolveAction,
  ): Promise<void> {
    console.warn(
      '[RUN:mock] adminUgc.resolveReport() is a no-op in mock mode',
    )
  }
}
